export const RoutesConfig = {
  Login: { path: '/login', fullPath: '/login' },
  Dashboard: { path: '/', fullPath: '/' },
  Companies: { path: '/companies', fullPath: '/companies' },
  CompanyDetail: { path: '/companies/:id', fullPath: '/companies/:id' },
  Users: { path: '/users', fullPath: '/users' },
  Machines: { path: '/machines', fullPath: '/machines' },
  MachineDetail: { path: '/machines/:id', fullPath: '/machines/:id' },
  Products: { path: '/products', fullPath: '/products' },
  Transactions: { path: '/transactions', fullPath: '/transactions' },
  Sessions: { path: '/sessions', fullPath: '/sessions' },
  TopupOrders: { path: '/orders', fullPath: '/orders' },
  TopupOrderDetail: { path: '/orders/:id', fullPath: '/orders/:id' },
  Wallets: { path: '/wallets', fullPath: '/wallets' },
  Revenue: { path: '/revenue', fullPath: '/revenue' },
  Emails: { path: '/emails', fullPath: '/emails' },
  EmailDetail: { path: '/emails/:id', fullPath: '/emails/:id' },
  Settings: { path: '/settings', fullPath: '/settings' },
} as const;
